import React from "react";
import { WavyBreak } from "../components/Wavy";
import { useSection } from "../context/SiteContext";

const Terms = () => {
  const { data: footer } = useSection("footer");
  return (
    <div className="bg-cream">
      <section className="pt-12 md:pt-20 pb-10 px-6 md:px-10 text-center">
        <h1 className="font-serif-display uppercase text-plum-deep text-4xl sm:text-5xl" data-testid="terms-title">
          TERMS AND CONDITIONS
        </h1>
      </section>
      <WavyBreak color="#EC2675" />
      <section className="px-6 md:px-10 py-12 max-w-[820px] mx-auto pb-24">
        <p className="text-plum-deep/85 text-base md:text-lg leading-relaxed whitespace-pre-line" data-testid="terms-body">
          {footer.terms || "Terms and conditions coming soon."}
        </p>
      </section>
    </div>
  );
};

export default Terms;
